<!-- 论坛-搜索 -->
<template>
	<div class="wrap">

		<div class="header-wrap">
			<div class="header">
				<img src="../assets/return.png" class="return-img" @click="$router.back()">
				<p class="header-title">搜索论坛</p>
			</div>
			<div class="search-box">
        <div class="search-bar" @click="$router.back()">
          <img src="../assets/search-icon.png" class="search-icon">
          <input
              type="search"
              ref="searchInput"
              placeholder="请输入关键字进行搜索"
              class="search-input"
              disabled
              :value="params.title"
          />
        </div>
			</div>
      <ul class="sub-tab-list" v-show="list.length > 0">
        <li :class="{ active: params.sort_type === 1 }" @click="checkTab(1)">默认排序</li>
        <li :class="{ active: params.sort_type === 2  || params.sort_type === 3}" @click="checkTab(params.sort_type === 3 ? 2 : 3)">
          时间
          <img src="../assets/icon-6.png" class="tab-icon" :style="{transform: `rotate(${params.sort_type === 3 || params.sort_type === 1 ? 0 : 180}deg)`}">
        </li>
      </ul>
		</div>


    <van-list
        style="width: 100%"
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        :finished-text="list.length > 0 ? '没有更多了' : ''"
        @load="getList"
    >
      <ul class="list">
        <li v-for="(item, index) in list" :key="index" @click="$router.push(`/forum-question-details?forum_id=${item.id}`)">
          <div class="item-top">
            <div class="item-top-left">
              <img :src="item.headimg" v-if="item.headimg">
              <img src="../assets/avatar.png" v-else>
              {{ item.name || `匿名用户` }}
            </div>
            <div class="item-top-right" v-if="item.level > 0">
              VIP
            </div>
          </div>
          <div class="item-center">
            <span class="item-center-left">Q</span>
            <div class="item-center-right">
              <p class="title" v-html="item.title"></p>
              <p class="msg" v-html="item.content"></p>
              <ul class="tag-list">
                <li v-for="(item, index) in item.label_name" :key="index">#{{ item }}</li>
              </ul>
            </div>
          </div>
          <div class="item-bottom">
            <div class="item-bottom-left" v-if="item.reply_num > 0">
              <img src="../assets/icon-43.png">
              {{ item.reply_num }}人回答
            </div>
            <div class="item-bottom-left" v-else>
              <img src="../assets/icon-43.png">
              暂无回答
            </div>
            <div class="item-bottom-right">
              <p class="eye-row">
                <img src="../assets/icon-36.png">
                {{ item.browse_num }}
              </p>
              <button type="button" class="more-btn">
                <img src="../assets/icon-10.png">
              </button>
            </div>
          </div>
        </li>
        <!-- 暂无数据展示 -->
        <div class="normal-box-small" v-if="list.length === 0">
          <img src="../assets/normal.png">
          暂无数据
        </div>
      </ul>
    </van-list>


		<div class="float-box">
			<button type="button" @click="$router.push('/feedback')">没找到？点我反馈</button>
		</div>


		<!-- 举报弹窗 -->
		<van-popup v-model="showReport" round position="bottom">
			<div class="window" style="position: relative!important">
				<div class="window-top">
					<button type="button" class="window-btn del" style="justify-content: flex-start"
						@click.stop="showReport = false; $router.push(`/report?type=${reportParams.type}&id=${reportParams.report_id}`)">
						<img src="../assets/icon-8.png">举报
					</button>
				</div>
				<div class="window-btn-box" @click="showReport = false">
					<button type="button">取消</button>
				</div>
			</div>
		</van-popup>
		<!-- 显示开通vip -->
		<van-overlay :show="showOpenVip" @click="showOpenVip = false" z-index="99999">
			<div class="open-vip">
				<p>仅支持VIP查看</p>
				<p>开通VIP查看本材料</p>
				<button @click="$router.push('/member')">开通VIP会员</button>
			</div>
		</van-overlay>


	</div>
</template>

<script>
	import {ForumService} from "@/common/service";

  export default {
		components: {},
		data() {
			return {
				showReport: false,
				showOpenVip: false,
				status: 0,
				// 举报参数
				// reportParams: {
				// 	type: 5, // 举报类型（1视频2视频评论3会员,4资料,5图文）
				// 	report_id: 0, // 举报内容的id
				// },
				params: {
					title: '', // 标题
					sort_type: 1, // 1默认2时间升序3时间降序
					page: 1, // 页数
					page_num: 20, // 每页数
				},
				list: [],
				loading: false,
				finished: false,

				// isLogin: false,
				// isVip: false,
			};
		},
		mounted() {
      const option = this.$route.query;
      this.params.title = option.key || '';
      this.getList();
    },
		methods: {
      checkTab(sortType) {
        this.params.sort_type = sortType;
        this.finished = false;
        this.params.page = 1;
        this.getList();
      },
      getList() {
        this.loading = true;
        ForumService.getForumList(this.params)
            .then(({ data }) => {
              const list = data.list.map(item => {
                item.title = item.title.replace(
                    RegExp(this.params.title, 'g'),
                    `<span style="color: #FF6700">${this.params.title}</span>`,
                );
                return item;
              });
              this.list = this.params.page === 1 ? list : [...this.list, ...list];
              if (list.length < this.params.page_num) {
                this.finished = true;
              } else {
                this.params.page++;
              }
            }).finally(() => {
          this.loading = false;
        }).catch(() => this.finished = true);
      },
    },
	}
</script>

<style scoped>
	/* 头部样式 */
	.header-wrap {
		width: 100%;
		height: 118px;
		display: flex;
		flex-direction: column;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 500;
		background-color: #FFFFFF;
	}

	.header-wrap-tab-list-none {
		height: 80px;
		padding-bottom: 10px;
	}

	.header {
		width: 100%;
		height: 44px;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #FFFFFF;
		z-index: 999;
		padding: 0 15px;
		position: relative;
		box-sizing: border-box;
	}

	.return-img {
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translate(0, -50%);
		width: 20px;
	}

	.header-title {
		color: #333333;
		font-size: 18px;
		font-weight: 500;
	}

	.search-box {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 0 15px;
		box-sizing: border-box;
	}

	.search-bar {
		flex: 1;
		height: 36px;
		background-color: #F3F3F3;
		border-radius: 100px;
		display: flex;
		align-items: center;
		padding: 0 15px;
		box-sizing: border-box;
	}

	.search-icon {
		width: 14px;
		margin-right: 8px;
	}

	.search-input {
		flex: 1;
		font-size: 14px;
	}

	.search-input::placeholder {
		color: #7F7F7F;
	}

	.tab-list>li {
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 38px;
		line-height: 38px;
		font-size: 16px;
		color: #555555;
		position: relative;
	}

	.tab-list>li.active {
		font-size: 18px;
		font-weight: 500;
		color: #222222;
	}

	.tab-list>li.active::after {
		content: "";
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translate(-50%, 0);
		background: linear-gradient(90deg, #2A63F3, #81B8FF);
		border-radius: 2px;
		width: 18px;
		height: 4px;
	}


	.sub-tab-list {
		width: 100%;
		height: 38px;
		display: flex;
		align-items: center;
	}

	.sub-tab-list>li {
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 38px;
		line-height: 38px;
		font-size: 14px;
		color: #555555;
		position: relative;
	}

	.sub-tab-list>li.active {
		font-weight: 500;
		color: #222222;
	}

	.sub-tab-list>li.active::after {
		content: "";
		width: 18px;
		height: 4px;
		background: linear-gradient(90deg, #2A63F3, #81B8FF);
		border-radius: 2px;
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translate(-50%, 0);
	}

	.tab-icon {
		width: 6px;
		margin-left: 2px;
	}

	.wrap {
		width: 100%;
		height: calc(100vh - 118px);
		display: flex;
		flex-direction: row;
		margin: 118px 0 0;
		box-sizing: border-box;
		background-color: #F4F4F4;
		overflow-y: auto;
	}

	.wrap-tab-list-none {
		height: calc(100vh - 90px);
		margin: 90px 0 0;
	}


	.sub-list {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 12px 15px;
		box-sizing: border-box;
		/*height: 100%;*/
		overflow: auto;
	}

	.sub-list>li {
		width: 100%;
		display: flex;
		align-items: center;
		background-color: #FFFFFF;
		box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
		border-radius: 12px;
		margin-bottom: 12px;
		padding: 10px;
		box-sizing: border-box;
		position: relative;
	}


	.sub-list>li:last-child {
		margin-bottom: 0;
	}

	.float-box {
		position: fixed;
		left: 50%;
		transform: translate(-50%, 0);
		bottom: 40px;
		z-index: 499;
	}

	.float-box>button {
		min-width: 175px;
		height: 44px;
		line-height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #2A63F3;
		border-radius: 100px;
		color: #FFFFFF;
		font-size: 18px;
		font-weight: 500;
	}

	.window {
		width: 100%;
		display: flex;
		flex-direction: column;
		/*position: fixed;*/
		/*bottom: 0;*/
		/*left: 0;*/
		z-index: 99999999;
		background-color: #FFFFFF;
		border-radius: 16px 16px 0 0;
	}

	.window-top {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 35px 25px;
		box-sizing: border-box;
	}

	.window-btn {
		width: 100%;
		display: flex;
		align-items: center;
		color: #222222;
		font-size: 16px;
		margin-bottom: 30px;
	}

	.window-btn:last-child {
		margin-bottom: 0;
	}

	.window-btn.del {
		color: #FF1010;
	}

	.window-btn>img {
		width: 24px;
		margin-right: 16px;
	}

	.window-btn2>img {
		height: 38px;
		margin-bottom: 5px;
	}

	.window-btn-box {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0 15px 38px;
		box-sizing: border-box;
	}

	.window-btn-box>button {
		width: 100%;
		height: 40px;
		line-height: 40px;
		background-color: #F3F3F3;
		border-radius: 100px;
		color: #222222;
		font-size: 16px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.window-btn-box2>button {
		color: #999999;
		font-size: 16px;
	}

	.list {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 12px 15px;
		box-sizing: border-box;
	}

	.list>li {
		width: 100%;
		background-color: #FFFFFF;
		box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
		border-radius: 12px;
		margin-bottom: 12px;
		padding: 0 10px 14px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
	}

	.item-top {
		width: 100%;
		height: 45px;
		line-height: 45px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.item-top-left {
		display: flex;
		align-items: center;
		color: #222222;
		font-size: 11px;
	}

	.item-top-left>img {
		width: 24px;
		height: 24px;
		border-radius: 50%;
		margin-right: 6px;
	}

	.item-top-right {
		color: #222222;
		font-size: 12px;
		font-weight: bold;
		height: 14px;
		line-height: 14px;
		padding: 0 8px;
		background: linear-gradient(90deg, #FFCD7C, #FFEEBA);
		border-radius: 50px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.item-center {
		width: 100%;
		display: flex;
		align-items: flex-start;
	}

	.item-center-left {
		color: #2A63F3;
		font-size: 10px;
		font-weight: bold;
		padding: 1px 3px;
		border: 1px solid #2A63F3;
		background-color: #E5ECFF;
		border-radius: 3px;
		box-sizing: border-box;
		margin-right: 6px;
		margin-top: 3px;
	}

	.item-center-right {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.title {
		width: 100%;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		color: #222222;
		font-size: 14px;
		font-weight: bold;
		margin-bottom: 5px;
	}

	.msg {
		width: 100%;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		color: #666666;
		font-size: 12px;
		margin-bottom: 5px;
	}

	.tag-list {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
	}

	.tag-list>li {
		width: fit-content;
		height: 16px;
		line-height: 16px;
		background-color: #F3F3F3;
		border-radius: 3px;
		margin-right: 6px;
		margin-bottom: 6px;
		color: #2A63F3;
		font-size: 10px;
		padding: 0 4px;
	}

	.item-bottom {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 10px;
	}

	.item-bottom-left {
		display: flex;
		align-items: center;
		color: #FFFFFF;
		font-size: 10px;
		background-color: #2A63F3;
		border-radius: 50px;
		height: 20px;
		line-height: 20px;
		padding: 0 7px;
		width: fit-content;
	}

	.item-bottom-left>img {
		width: 12px;
		margin-right: 3px;
	}

	.item-bottom-right {
		display: flex;
		align-items: center;
	}

	.eye-row {
		display: flex;
		align-items: center;
		color: #999999;
		font-size: 11px;
	}

	.eye-row>img {
		width: 16px;
		margin-right: 4px;
	}

	.more-btn {
		width: 16px;
		height: 16px;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		margin-left: 10px;
	}

	.more-btn>img {
		height: 3px;
	}

	.normal-box-small {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: 14px;
		color: #999992;
		padding: 120px 0;
	}

	.normal-box-small>img {
		width: 150px;
		margin-bottom: 9px;
	}
</style>
